import { Tranche } from "@lib/tranche";
import Matrix from "algorithm/matrix";
import Vector from "algorithm/vector";

/**
 * Convert an incremental tranche list to a cumulative tranche list.
 */
export function trancheListToAlgoTranches(
  tranches: Tranche[],
  evaluableIndicesMap: { [evaluableId: string]: number },
  evaluableMaxAllocations: { [evaluableId: string]: number | null },
  evaluableIdWhitelist: Set<string>,
): Matrix<"tranche", "evaluable+hold"> {
  const numEvaluables = Object.keys(evaluableIndicesMap).length;
  const result = Matrix.zeros<"tranche", "evaluable+hold">(
    tranches.length,
    numEvaluables,
  );

  for (let row = 0; row < tranches.length; row++) {
    const tranche = tranches[row];
    const prevRow =
      row === 0 ? Vector.zeros(numEvaluables) : result.getRow(row - 1);

    for (const [evaluableId, col] of Object.entries(evaluableIndicesMap)) {
      if (!evaluableIdWhitelist.has(evaluableId)) continue;

      const x =
        prevRow.get(col) + (tranche.allocations[evaluableId]?.amount ?? 0);
      const maxAlloc = evaluableMaxAllocations[evaluableId] ?? Infinity;
      const alloc = Math.min(x, maxAlloc);
      result.set(row, col, alloc);
    }
  }

  return result;
}
